import { ADD_NOTES, FETCHING_NOTES, FETCHED_NOTES } from '../constants';

interface NotesState {
  list: Record<string, any[]>;
  fetching: boolean;
  fetched: Record<string, number>;
}

const initialState: NotesState = {
  list: {},
  fetching: false,
  fetched: {},
};

export default function notesReducer(
  state = initialState,
  { type, payload }: { type: string; payload?: any },
): NotesState {
  switch (type) {
    case ADD_NOTES:
      return {
        ...state,
        list: { ...state.list, [String(payload.project_id)]: payload.list },
      };
    case FETCHING_NOTES:
      return { ...state, fetching: payload };
    case FETCHED_NOTES:
      return { ...state, fetched: { ...state.fetched, [String(payload.project_id)]: Date.now() } };
    default:
      return state;
  }
}
